import React, {useEffect, useState} from 'react';

import {
    getAfkConfigByCompanyId,
    getClientExpirationTime,
    getClientWebChatConf,
    getCompanyConvVis,
    getCompanyMessageConfig,
    getCompanyReminderConfigs,
    getCompanyTextAction,
    getCompanyWorkingHours,
    getOperatorInactivityActionConfigByCompanyId
} from "../../../../../../services/company/api";

import config from "../../../../../../config";
import AutoConnectCheckbox from "./functions/AutoConnectCheckbox";
import ReminderSettings from "./functions/ReminderSettings";
import ExpirationSettings from "./functions/ExpirationSettings";
import TriggerSettings from "./functions/TriggerSettings";
import TextActionSelector from "./functions/TextActionSelector";
import WorkingHoursSettings from "./functions/WorkingHoursSettings";
import MessageConfig from "./functions/MessageConfig";
import ConversationVisibilityConfig from "./functions/ConversationVisibilityConfig";
import ChatInactivityAction from "./functions/ChatInactivityAction";
import OperatorInactivityAction from "./functions/OperatorInactivityAction";

const styles = {
    title: {
        fontSize: '18px',
        padding: '20px 40px',
        color: '#A4ADC1',
        marginBottom: '15px'
    },
    sectionTitle: {
        fontSize: '16px',
        color: '#A4ADC1',
    },
    bottomMargin: {
        marginBottom: '20px',
    },
    flexblock: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'space-between'
    },
    functionblock: {
        background: 'white',
        borderRadius: '10px',
        padding: '10px',
        flex: '1 1 calc(33.33% - 20px)',
        minHeight: '200px',
        boxSizing: 'border-box',
    }
};


const Functions = ({tariff, client, user}) => {
    const {features} = tariff;
    const [expiration, setExpiration] = useState();
    const [afkConfig, setAfkConfig] = useState({});
    const [operatorInactivityAction, setOperatorInactivityAction] = useState({});
    const [triggers, setTriggers] = useState({openAfterPeriod: -1});
    const [textAction, setTextAction] = useState("");
    const [convVis, setConvVis] = useState("");
    const [workingHours, setWorkingHours] = useState({startHour: '00:00', endHour: '00:00'});
    const [reminderData, setReminderData] = useState({});
    const [messageConfigData, setMessageConfigData] = useState({});


    useEffect(() => {
        getClientExpirationTime(client.id).then(setExpiration);
        getAfkConfigByCompanyId(client.id).then(setAfkConfig);
        getOperatorInactivityActionConfigByCompanyId(client.id).then(setOperatorInactivityAction);
        getClientWebChatConf(client.id).then((data) => {
            setTriggers(data.triggers);
        });
        getCompanyTextAction(client.id).then(setTextAction);
        getCompanyConvVis(client.id).then(setConvVis);
        getCompanyWorkingHours(client.id).then((data) => {
            if (data) {
                setWorkingHours({
                    startHour: data.start || '00:00',
                    endHour: data.end || '00:00'
                });
            }
        });
        getCompanyReminderConfigs(client.id).then(setReminderData);
        getCompanyMessageConfig(client.id).then(setMessageConfigData);
    }, [client.id]);


    return (
        <div style={styles.flexblock}>

            {(features.includes(config.features.CONVERSATION_VISIBILITY) && (
                <div style={styles.functionblock}>
                    <ConversationVisibilityConfig features={features} client={client} user={user} convVis={convVis}
                                                  setConvVis={setConvVis}/>
                </div>
            ))}

            {features.includes(config.features.OPERATOR_CONNECT_LOGIC) && (
                <div style={styles.functionblock}>
                    <AutoConnectCheckbox features={features} client={client} user={user}/>
                </div>
            )}

            {features.includes(config.features.EXPIRATION_TIME) && (
                <div style={styles.functionblock}>
                    <ExpirationSettings expiration={expiration} client={client}/>
                </div>
            )}

            {features.includes(config.features.USER_INACTIVITY_ACTION) && (
                <div style={styles.functionblock}>
                    <ChatInactivityAction setAfkConfig={setAfkConfig} afkConfig={afkConfig} client={client}/>
                </div>
            )}

            {features.includes(config.features.OPERATOR_INACTIVITY_ACTION) && (
                <div style={styles.functionblock}>
                    <OperatorInactivityAction user={user} setOperatorInactivityAction={setOperatorInactivityAction}
                                              operatorInactivityAction={operatorInactivityAction} client={client}/>
                </div>
            )}

            {(features.includes(config.features.TYPING_MESSAGES_FOR_OPERATOR)
                || features.includes(config.features.MESSAGE_EDIT)
                || features.includes(config.features.MESSAGE_DELETE)) && (
                <div style={styles.functionblock}>
                    <MessageConfig features={features} client={client} messageConfigData={messageConfigData}
                                   setMessageConfigData={setMessageConfigData}/>
                </div>
            )}

            {features.includes(config.features.WEBCHAT_TRIGGER) && (
                <div style={styles.functionblock}>
                    <TriggerSettings commonStyles={styles}
                                     triggers={triggers}
                                     setTriggers={setTriggers}
                                     clientId={client.id}/>
                </div>
            )}

            {(features.includes(config.features.TEXT_ACTION_NO_AI))
                && client.type === config.companyTypeMap.scenario && (
                    <div style={styles.functionblock}>
                        <TextActionSelector features={features} client={client} user={user} textAction={textAction}
                                            setTextAction={setTextAction}/>
                    </div>
                )}

            {features.includes(config.features.WORKING_HOURS) && (
                <div style={styles.functionblock}>
                    <WorkingHoursSettings client={client} workingHours={workingHours}
                                          setWorkingHours={setWorkingHours}/>
                </div>
            )}

            {(features.includes(config.features.REMINDERS_NO_AI)) && (
                <div style={styles.functionblock}>
                    <ReminderSettings features={features} client={client} user={user} reminderData={reminderData}
                                      setReminderData={setReminderData}/>
                </div>
            )}

        </div>
    );
};

export default Functions;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Functions.jsx